import React, { ReactElement } from 'react'
import Slider from 'react-slick'
import Link from 'next/link'
import routesConfig from '@mindfulchefuk/config/routesConfig'
import { IMAGE_PATH_PREFIX } from '@mindfulchefuk/constants'
import { Flex, Grid, Text, Icon } from '@mindfulchefuk/design-system'

import {
  SearchCategoryImage,
  SearchCategorySlider,
} from './QuickSearchCategories.styles'

type TSearchCategoryItem = {
  title: string
  image: string
  filterType: string
  filterValue: string
}

type TQuickSearchImageLink = {
  categories: Array<TSearchCategoryItem>
}

const QuickSearchImageLink = ({
  title,
  image,
  filterType,
  filterValue,
}: TSearchCategoryItem): ReactElement => (
  <Link
    href={{
      pathname: routesConfig.recipes.pathname,
      query: { [filterType]: filterValue },
    }}
    as={`${routesConfig.recipes.as}?${filterType}=${filterValue}`}
    passHref
  >
    <a>
      <SearchCategoryImage
        src={IMAGE_PATH_PREFIX + image}
        imgixParams={{ fit: 'crop' }}
      >
        <Flex
          align="center"
          justify="space-between"
          position="relative"
          width="100%"
        >
          <Text variant="heading-sm" color="white" position="relative">
            {title}
          </Text>
          <Icon type="arrow-right" color="white" size={24} />
        </Flex>
      </SearchCategoryImage>
    </a>
  </Link>
)

const QuickSearchCategories = ({
  categories,
}: TQuickSearchImageLink): ReactElement => {
  const quickSearchImageLinks = categories.map(
    ({ title, image, filterType, filterValue }) => (
      <QuickSearchImageLink
        key={title}
        title={title}
        image={image}
        filterType={filterType}
        filterValue={filterValue}
      />
    )
  )

  return (
    <>
      <SearchCategorySlider>
        <Slider dots speed={500} slidesToShow={1}>
          {quickSearchImageLinks}
        </Slider>
      </SearchCategorySlider>

      <Grid
        columnGap={32}
        templateColumns="1fr 1fr 1fr"
        display={{ base: 'none', md: 'grid' }}
      >
        {quickSearchImageLinks}
      </Grid>
    </>
  )
}

export default QuickSearchCategories
